<template>
  <v-layout row wrap>
    <v-flex xs12 md6>
      <v-layout align-center row>
        <slot name="titleTarget"></slot>
      </v-layout>
      <div class="ml-3 mt-3">
        <TargetAudience
          :selected="target"
          @selected="onSelected"
          :target-type="targetType"
        />
      </div>
    </v-flex>
    <v-flex xs12 md6>
      <v-layout align-center row>
        <slot name="titleItems"></slot>
      </v-layout>
      <div class="ml-3 mt-4 border-container">
        <!-- INSTITUTION -->
        <div v-if="target === 'INSTITUTION'" class="flex-align_center pa-3">
          <BoxIcon>
            <img :src="require('@/assets/icons/office_building.svg')" alt="" />
          </BoxIcon>
          <p class="mt-3 mb-0 title font-weight-medium mb-1">Institucional</p>
          <p class="mb-0 text--secondary subheading font-weight-Regular mb-1">
            Todos los alumnos serán agregados a la ruta
          </p>
        </div>

        <!-- LEVELS -->
        <div v-if="target === 'LEVELS'" class="flex-align_center pa-3">
          <div>
            <BoxIcon>
              <v-icon color="white">school</v-icon>
            </BoxIcon>
            <input
              type="text"
              class="border-container ml-2 pa-2"
              style="
                height: 40px;
                width: 100%;
                max-width: 300px;
                font-size: 1.2em;
              "
              v-model="levels.search"
              @input="levels.searchItemsHandler()"
            />
          </div>
          <p class="mt-3 mb-0 pb-2 title font-weight-medium">Niveles</p>
          <CustomChip
            v-for="item in levels.resultSearchedItems"
            :is-selected="item.isSelected"
            :text="item.levelName"
            @click="change(levels.changeItem, item, 'LEVELS')"
          />
        </div>

        <!-- EXTRA LEVELS -->
        <div v-if="target === 'EXTRA_LEVELS'" class="flex-align_center pa-3">
          <div>
            <BoxIcon>
              <v-icon color="white">school</v-icon>
            </BoxIcon>
            <input
              type="text"
              class="border-container ml-2 pa-2"
              style="
                height: 40px;
                width: 100%;
                max-width: 300px;
                font-size: 1.2em;
              "
              v-model="extraLevels.search"
              @input="extraLevels.searchItemsHandler()"
            />
          </div>
          <p class="mt-3 mb-0 pb-2 title font-weight-medium">
            Niveles Extracurriculares
          </p>
          <CustomChip
            v-for="item in extraLevels.resultSearchedItems"
            :is-selected="item.isSelected"
            :text="item.levelName"
            @click="change(extraLevels.changeItem, item, 'EXTRA_LEVELS')"
          />
        </div>

        <!-- GROUPS -->
        <div v-if="target === 'GROUPS'" class="flex-align_center pa-3">
          <div>
            <BoxIcon>
              <v-icon color="white">school</v-icon>
            </BoxIcon>
            <input
              type="text"
              class="border-container ml-2 pa-2"
              style="
                height: 40px;
                width: 100%;
                max-width: 300px;
                font-size: 1.2em;
              "
              v-model="groups.search"
              @input="groups.searchItemsHandler()"
            />
          </div>
          <p class="mt-3 mb-0 pb-2 title font-weight-medium">Grupos</p>
          <CustomChip
            v-for="item in groups.resultSearchedItems"
            :is-selected="item.isSelected"
            :text="`${item.levelName}. ${item.groupName}`"
            @click="change(groups.changeItem, item, 'GROUPS')"
          />
        </div>

        <!-- SUBGROUPS -->
        <div v-if="target === 'SUBGROUPS'" class="flex-align_center pa-3">
          <div>
            <BoxIcon>
              <v-icon color="white">school</v-icon>
            </BoxIcon>
            <input
              type="text"
              class="border-container ml-2 pa-2"
              style="
                height: 40px;
                width: 100%;
                max-width: 300px;
                font-size: 1.2em;
              "
              v-model="subgroups.searchItems"
              @input="subgroups.getItemsDebounced()"
            />
          </div>
          <p class="mt-3 mb-0 pb-2 title font-weight-medium">Subgrupos</p>
          <v-layout
            v-if="students.loading"
            align-center
            justify-center
            row
            class="loading_height"
          >
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </v-layout>
          <div v-else class="items_box_pills">
            <CustomChip
              v-for="group in subgroups.resultSearchedItems"
              :is-selected="group.isSelected"
              :text="`${group.levelName}. ${group.groupName}`"
              @click="change(subgroups.changeItem, group, 'SUBGROUPS')"
            />
          </div>
          <br />
          <v-pagination
            class="pagination"
            v-model="subgroups.page"
            :length="subgroups.totalPages"
            @input="subgroups.getItemsDebounced()"
          ></v-pagination>
        </div>

        <!-- STUDENTS -->
        <div v-if="target === 'STUDENTS'" class="flex-align_center pa-3">
          <div>
            <BoxIcon>
              <v-icon color="white">school</v-icon>
            </BoxIcon>
            <input
              type="text"
              class="border-container ml-2 pa-2"
              style="
                height: 40px;
                width: 100%;
                max-width: 300px;
                font-size: 1.2em;
              "
              v-model="students.searchItems"
              @input="students.getItemsDebounced()"
            />
          </div>
          <p class="mt-3 mb-0 pb-2 title font-weight-medium">Alumnos</p>
          <v-layout
            v-if="students.loading"
            align-center
            justify-center
            row
            class="loading_height"
          >
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </v-layout>
          <div v-else class="items_box_pills">
            <CustomChip
              v-for="item in students.resultSearchedItems"
              :is-selected="item.isSelected"
              :text="item.fullName"
              @click="change(students.changeItem, item, 'STUDENTS')"
            />
          </div>
          <br />
          <v-pagination
            class="pagination"
            v-model="students.page"
            :length="students.totalPages"
            @input="students.getItems()"
          ></v-pagination>
        </div>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  ChipLevel,
  ChipStudent,
  InitialAudienceData,
  LevelsGroupsHandler,
  StudentType,
  StudentsOrSubgroupHandler,
  parseChipStudentsFromArray,
  parseGroupsFromArray,
  parseLevelsFromArray,
  parseSubGroups,
} from '../../Mixins/audience.js'
import BoxIcon from './boxIcon.vue'
import CustomChip from './customChip.vue'
import TargetAudience from './targetAudience.vue'

export default {
  props: {
    targetType: {
      type: StudentType,
    },
    idRoute: {
      type: Number,
      default: undefined,
    },
  },
  components: {
    TargetAudience,
    BoxIcon,
    CustomChip,
  },
  data: () => ({
    /**
     * @type {StudentsOrSubgroupHandler}
     */
    subgroups: undefined,
    /**
     * @type {LevelsGroupsHandler}
     */
    extraLevels: undefined,
    /**
     * @type {LevelsGroupsHandler}
     */
    levels: undefined,
    /**
     * @type {LevelsGroupsHandler}
     */
    groups: undefined,
    /**
     * @type {StudentsOrSubgroupHandler}
     */
    students: undefined,
    /**
     * @type {'INSTITUTION'|'LEVELS'|'EXTRA_LEVELS'|'GROUPS'|'SUBGROUPS'|'STUDENTS'}
     */
    target: 'INSTITUTION',
  }),
  async mounted() {
    await new Promise((res, _) => {
      this.initLevelsGradeGroupslevels().then((e) => {
        if (e === undefined) return

        this.extraLevels = new LevelsGroupsHandler(
          'levelId',
          parseLevelsFromArray,
          e.extracurricular
        )
        this.levels = new LevelsGroupsHandler(
          'levelId',
          parseLevelsFromArray,
          e.levels
        )
        this.groups = new LevelsGroupsHandler(
          'groupId',
          parseGroupsFromArray,
          e.levels
        )
        res()
      })
    })

    this.subgroups = new StudentsOrSubgroupHandler({
      targetId: 'groupId',
      api: this.$store,
      apiUrl: 'subgroups/getSubgroups',
      itemParser: parseSubGroups,
    })

    this.students = new StudentsOrSubgroupHandler({
      targetId: 'id',
      api: this.$store,
      apiUrl: 'student/getSelectedStudentsFirst',
      itemParser: parseChipStudentsFromArray,
      studentsParams: { idRoute: this.idRoute, type: this.targetType },
    })

    this.subgroups.getItems()
    this.students.getItems()
    this._emitTarget()
    this.$emit('ready')
  },
  methods: {
    /**
     * @param {'INSTITUTION'|'LEVELS'|'EXTRA_LEVELS'|'GROUPS'|'SUBGROUPS'|'STUDENTS'} selected
     */
    onSelected(selected) {
      this.target = selected
      this._emitTarget()
      this._emitSelectedIds(selected)
    },
    async initLevelsGradeGroupslevels() {
      try {
        const { data } = await this.$store.dispatch('tutor/getLevelsExtraTool')

        return data.entity
      } catch (error) {
        console.log(error)
        return
      }
    },
    _emitTarget() {
      this.$emit('selectedAudience', this.target)
    },
    /**
     * @param {'INSTITUTION'|'LEVELS'|'EXTRA_LEVELS'|'GROUPS'|'SUBGROUPS'|'STUDENTS'} applyTo
     */
    _emitSelectedIds(applyTo) {
      const e = {
        INSTITUTION: '',
        LEVELS: 'levels',
        EXTRA_LEVELS: 'extraLevels',
        GROUPS: 'groups',
        SUBGROUPS: 'subgroups',
        STUDENTS: 'students',
      }
      if (applyTo === 'INSTITUTION') {
        this.$emit('selectedItemsIds', [])
        return
      }

      this.$emit('selectedItemsIds', this[e[applyTo]].selectedItemsToIds())
    },
    /**
     * @param {ChipLevel|ChipStudent} args
     * @param {'INSTITUTION'|'LEVELS'|'EXTRA_LEVELS'|'GROUPS'|'SUBGROUPS'|'STUDENTS'} applyTo
     */
    change(cb, args, applyTo) {
      cb(args)
      this._emitSelectedIds(applyTo)
    },
    /**
     * @param {InitialAudienceData} data
     */
    initialData(data) {
      const e = {
        INSTITUTION: '',
        LEVELS: 'levels',
        EXTRA_LEVELS: 'extraLevels',
        GROUPS: 'groups',
        SUBGROUPS: 'subgroups',
        STUDENTS: 'students',
      }

      if (data.target !== 'INSTITUTION') {
        for (let i = 0; i < data.itemsIds.length; i++) {
          this[e[data.target]].selectedItemsIds.set(
            data.itemsIds[i],
            data.itemsIds[i]
          )
        }
        this[e[data.target]].setSelectedItems()
      }

      this.target = data.target
      this._emitSelectedIds(data.target)
      this._emitTarget()
    },
  },
}
</script>
<style scoped>
.border-container {
  border: 1px solid;
  border-color: #ccc;
  border-radius: 0.5rem;
  overflow: hidden;
}
</style>
